import React from 'react';
import {Message} from 'epic-diesel-common';
import {OverviewFAQs} from '../../../reducers/overview';

//@ts-ignore
import styles from './FAQSection.pcss';

export type FAQSectionProps = OverviewFAQs;

const FAQSection: React.FC<FAQSectionProps> = ({faqItem = []}) => (
    <div className={styles.section}>
        <div className={styles.container}>
            <h2>
                <Message code="epic.affiliate.overview.faq" />
            </h2>
            {faqItem.map((item, key) => (
                <div id={item.anchor} className={styles.detail} key={key}>
                    <h6 dangerouslySetInnerHTML={{__html: item.title}} />
                    <div dangerouslySetInnerHTML={{__html: item.answer}} />
                </div>
            ))}
        </div>
    </div>
);

export default FAQSection;
